import { useCallback, useState } from "react";
import { safeLocalGetIn, safeLocalRemove, safeLocalSet } from "src/utils/storage";
import { CONSENT_KEY, CONSENT_VALUES, analyticsEnabled, applyConsent } from "src/analytics/gtag";

// Cookie-consent state for the banner. Choice is persisted as a plain string
// ("granted" | "denied") in localStorage and mapped onto Consent Mode v2.
// The banner only shows when tracking is actually configured (analyticsEnabled)
// AND the visitor has not decided yet — so with no GA4/Ads IDs there is no
// banner and no cookies.
// Call this hook ONCE (in App) and pass the instance down — the banner and the
// footer "Evästeasetukset" link must share the same state or reopening won't
// re-render the banner. `reopen` clears the stored choice so the visitor can
// change their mind (GDPR art. 7(3): withdrawing must be as easy as giving).
export function useCookieConsent() {
    const [choice, setChoice] = useState(() => safeLocalGetIn(CONSENT_KEY, CONSENT_VALUES));

    const decide = useCallback((granted) => {
        const value = granted ? "granted" : "denied";
        safeLocalSet(CONSENT_KEY, value);
        setChoice(value);
        applyConsent(granted);
    }, []);

    return {
        choice,
        available: analyticsEnabled,
        showBanner: analyticsEnabled && choice == null,
        accept: useCallback(() => decide(true), [decide]),
        reject: useCallback(() => decide(false), [decide]),
        reopen: useCallback(() => {
            safeLocalRemove(CONSENT_KEY);
            setChoice(null);
        }, []),
    };
}
